<template>
  <Teleport to="body">
    <div v-show="modalActive" class="modal-bg" @click.self="$emit('close')">
      <div class="modal">
        <div class="modal-header">
          <div class="image-holder">
            <img @contextmenu.prevent :src="require(`../assets/buildingLayout/${imageName}`)">
            <!-- <img src="../assets/buildingLayout/SIM-fl0.jpg" > -->
          </div>
        </div>

        <!-- <div class="modal-content"> -->
          <!-- <button class="cancel" :disabled="requestLoading" @click="$emit('close')">Hủy</button> -->
          <!-- <button class="delete" @click="$emit('delete')">
            <i class="fa-solid fa-trash"></i> Yes, Delete</button> -->
          <!-- <button class="delete" @click="$emit('delete')">
            <p class="btn-text"><i class="fa-solid fa-trash"></i> Xóa</p>
          </button>
        </div> -->
      </div>
    </div>
  </Teleport>
</template>
<script>
export default {
  props: {
    modalActive: {
      type: Boolean,
      require: false,
      default: false
    },
    imageName: {
      type: String,
      require: true,
      default: ''
    }
  },
  emits: ['close', 'delete']
}
</script>
<style scoped>
.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.modal {
  padding: 16px;
  background: #fff;
  width: 750px;
  align-self: center;
  border-radius: 12px;
}

.modal-header {
  margin-bottom: 0px;
}

.modal-header h2 {
  margin-bottom: 10px;
}

.modal-header p {
  color: #ababab;
  font-size: 15px;
}

.modal-content {
  display: flex;
  justify-content: flex-end;
}

.modal-content button {
  position: relative;
  margin-left: 20px;
  padding: 10px 20px;
  border-radius: 15px;
  outline: none;
  border: none;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
}

.modal-content .delete {
  color: #fff;
  background: red;
}

.modal-content .cancel {
  color: #969393;
  background: #efebeb;
}

.modal-content i {
  margin-right: 5px;
}

.btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .image-holder img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (min-width: 1650px) {
    .modal {
      width: 950px;
    }
  }

  @media (min-width: 1850px) {
    .modal {
      width: 1050px;
    }
  }
</style>
